type CatalogItem = { id?: number; name?: string | null };

export const resolveCatalogId = (
  items: CatalogItem[] | undefined,
  expectedName: string,
  catalogName: string,
): number => {
  const normalizedExpectedName = normalizeCatalogName(expectedName);
  const matches = (items ?? []).filter(
    item => item.id !== undefined && normalizeCatalogName(item.name) === normalizedExpectedName,
  );

  if (matches.length !== 1) {
    throw new Error(`${catalogName} '${expectedName}' could not be resolved unambiguously.`);
  }

  return matches[0].id!;
};

const normalizeCatalogName = (value: string | null | undefined): string =>
  (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
